
import React from "react";
import { Star } from "lucide-react";
import { useKarma } from "./useKarma";
import KarmaStats from "./KarmaStats";
import PointsControls from "./PointsControls";
import ActivityHistory from "./ActivityHistory";
import KarmaAchievements from "./KarmaAchievements";
import KarmaLeaderboard from "./KarmaLeaderboard";
import { useAuth } from "@/contexts/AuthContext";

const KudosSystem = () => {
  const {
    karmaPoints,
    activities,
    loading,
    availablePoints,
    claimPoints,
    getCurrentLevel,
    getProgressToNextLevel,
    levelThresholds,
    leaderboard,
    loadingLeaderboard
  } = useKarma();
  
  const { user } = useAuth();

  if (loading) {
    return (
      <div className="p-6 bg-card rounded-lg shadow-sm border">
        <div className="flex justify-center items-center py-12">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
        </div>
      </div>
    );
  }

  return (
    <div className="p-6 bg-card rounded-lg shadow-sm border">
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-xl font-bold flex items-center gap-2">
          <Star className="text-yellow-500" />
          Karma Points
        </h2>
      </div>
      
      <div className="grid grid-cols-1 gap-6">
        {/* Points display and controls */}
        <div className="space-y-6">
          <KarmaStats 
            karmaPoints={karmaPoints}
            levelThresholds={levelThresholds}
            getCurrentLevel={getCurrentLevel}
            getProgressToNextLevel={getProgressToNextLevel}
          />
          <PointsControls 
            availablePoints={availablePoints}
            claimPoints={claimPoints}
          />
          <KarmaAchievements karmaPoints={karmaPoints} />
        </div>
        
        {/* Activity history and leaderboard */}
        <div className="space-y-6">
          <ActivityHistory activities={activities} />
          <KarmaLeaderboard 
            leaderboard={leaderboard} 
            loading={loadingLeaderboard} 
            currentUserId={user?.id}
          />
        </div>
      </div>
    </div>
  );
};

export default KudosSystem;
